import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import AdminQuestionDataTable from './AdminQuestionDataTable';
import AddQuestion from './AddQuestion';
import Guidelines from './Guidelines';

function AdminTabs(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: { xs: 1, sm: 3 } }}>{children}</Box>
            )}
        </div>
    );
}

AdminTabs.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs({ user }) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label='basic tabs example'
                    variant="scrollable"
                    scrollButtons="auto" // show arrows when needed
                >
                    <Tab
                        label='Review'
                        {...a11yProps(0)}
                    />
                    <Tab
                        label='Add'
                        {...a11yProps(1)}
                    />
                    <Tab
                        label='Guidelines'
                        {...a11yProps(2)}
                    />
                </Tabs>
            </Box>
            <AdminTabs
                value={value}
                index={0}
            >
                <AdminQuestionDataTable user={user} />
            </AdminTabs>
            <AdminTabs
                value={value}
                index={1}
            >
                <AddQuestion user={user} />
            </AdminTabs>
            <AdminTabs
                value={value}
                index={2}
            >
                <Guidelines />
            </AdminTabs>
        </Box>
    );
}